const MuiLinearProgress = {
  styleOverrides: {
    colorPrimary: ({
      theme
    }) => ({
      backgroundColor: theme.palette.primary[50]
    }),
    bar: {
      borderRadius: 8
    }
  }
};
export default MuiLinearProgress;